import { useDispatch } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { closeErrorOrWarningDialog } from "../../Redux/Actions/InputData";
import ErrorIcon from "@mui/icons-material/ErrorOutlined";
import "./errorstyle.css";
import { Button, DialogActions, Typography } from "@mui/material";
import { yellow } from "@mui/material/colors";

function ErrorOrWarningDialog(props: any) {
  const dispatch: any = useDispatch();

  const handleCloseErrorDialog = () => {
    dispatch(closeErrorOrWarningDialog());
  };

  return (
    <>
      <Dialog
        onClose={handleCloseErrorDialog}
        aria-labelledby="customized-dialog-title"
        open={props.isErrorOrWarningDialog}
      >
        <DialogTitle id="customized-dialog-title">
          <ErrorIcon sx={{ color: yellow[500], fontSize: 30 }} />
          <div className="modal-error-title">Warning</div>
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            {props.errorOrWarningMessage ? (
              <div>{props.errorOrWarningMessage}</div>
            ) : (
              <div>Network Connection Error! Please Try after Sometime...</div>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseErrorDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ErrorOrWarningDialog;
